module.exports = __webpack_public_path__ + "media/packs/images/flags/GN-0f7b726239cf3821214dc5e381456d85.svg";